import React from "react";
import ExcelJS from "exceljs";

const ExcelReassignReport = ({ data }) => {
    const exportExcelFile = async () => {
        if (!Array.isArray(data) || data.length === 0) {
            console.error("Data is not an array or empty:", data);
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Reassign Report');

        // Define columns with headers based on your table structure
        worksheet.columns = [
            { header: 'S.No', key: 'serial', width: 8 },
            { header: 'File No', key: 'file_id', width: 15 },
            { header: 'Login Date', key: 'login_dt', width: 20 },
            { header: 'Re-Assign Date', key: 'reassign_dt', width: 20 },
            { header: 'Re-Assign By', key: 'reassign_by', width: 25 },
            { header: 'Previous Process Officer', key: 'previous_po', width: 25 },
            { header: 'Current Process Officer', key: 'current_po', width: 25 },
            { header: 'Previous Verification Officer', key: 'previous_vo', width: 25 },
            { header: 'Current Verification Officer', key: 'current_vo', width: 25 },
            { header: 'File Branch', key: 'lh_branch', width: 20 },
            { header: 'Bank Name', key: 'bank_name', width: 30 },
        ];

        // Apply alignment and color to header cells
        worksheet.getRow(1).eachCell((cell) => {
            cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFF00' }, // Yellow color
            };
            cell.font = { bold: true, size: 12 };
        });

        // Use the already processed data or process it if needed
        const flattenedData = data.map((item, index) => {
            return {
                serial: index + 1,
                file_id: item.file_id || '-',
                login_dt: item.login_dt || '-',
                reassign_dt: item.reassign_dt || '-',
                reassign_by: item.reassign_by || '-',
                previous_po: item.previous_po || '-',
                current_po: item.current_po || '-',
                previous_vo: item.previous_vo || '-',
                current_vo: item.current_vo || '-',
                lh_branch: item.lh_branch || '-',
                bank_name: item.bank_name || '-',
            };
        });

        // Add data rows with custom cell alignment
        flattenedData.forEach((item) => {
            const row = worksheet.addRow(item);

            // Apply formatting to each cell
            row.eachCell((cell, colNumber) => {
                // Default alignment for all cells
                cell.alignment = {
                    vertical: 'middle',
                    horizontal: 'center',
                    wrapText: true
                };

                // Special formatting for specific columns
                if (colNumber === 1) { // S.No column
                    cell.font = { bold: true };
                } else if (colNumber === 2) { // File No column
                    cell.alignment = { vertical: 'middle', horizontal: 'left' };
                } else if (colNumber === 11) { // Bank Name column
                    cell.alignment = { vertical: 'middle', horizontal: 'left' };
                }

                // Date formatting for date columns
                if ([3, 4].includes(colNumber)) { // Login Date and Re-Assign Date
                    // Check if the value looks like a date
                    const cellValue = cell.value;
                    if (cellValue && typeof cellValue === 'string' && cellValue !== '-') {
                        // Try to format as date if it's a valid date string
                        const dateObj = new Date(cellValue);
                        if (!isNaN(dateObj.getTime())) {
                            cell.value = dateObj;
                            cell.numFmt = 'dd-mm-yyyy'; // Format as DD-MM-YYYY
                        }
                    }
                }
            });
        });

        // Add borders to all cells for better readability
        worksheet.eachRow((row) => {
            row.eachCell((cell) => {
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
            });
        });

        // Set header row height
        worksheet.getRow(1).height = 30;

        // Auto-filter for better data management
        worksheet.autoFilter = {
            from: 'A1',
            to: `${String.fromCharCode(64 + worksheet.columns.length)}1`
        };

        const currentDate = new Date();
        const formattedDate = `${currentDate.getDate().toString().padStart(2, '0')}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-${currentDate.getFullYear()}`;

        // Generate Excel file buffer
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = `Reassign_Report_${formattedDate}.xlsx`;
        anchor.click();
        window.URL.revokeObjectURL(url);
    };

    return (
        <button
            className="btn btn-success mt-1 mb-2"
            onClick={exportExcelFile}
        >
            <i className="feather icon-download"></i> Download as Excel
        </button>
    );
};

export default ExcelReassignReport;